import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { PaginationModel } from "@thkStore/Store/Widgets/ExemptionCertificateList/Handlers/LoadExemptionCertificates";
import React from "react";

export interface ExemptionCertificateListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const exemptionCertificateListPaginationStyles: ExemptionCertificateListPaginationStyles = {};

const styles = exemptionCertificateListPaginationStyles;

interface Props {
    pagination?: PaginationModel;
    currentPage: number;
    pageSize: number;
    onChangePage: (page: number) => void;
    onChangeResultsPerPage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ExemptionCertificateListPagination: React.FC<Props> = ({
    pagination,
    currentPage,
    pageSize,
    onChangePage,
    onChangeResultsPerPage,
}) => {
    if (!pagination || pagination.totalItemCount <= 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={currentPage}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions || [10, 25, 50]}
            onChangePage={onChangePage}
            onChangeResultsPerPage={onChangeResultsPerPage}
            pageSizeCookie="ExemptionCertificateList-PageSize"
            prevPage={pagination.prevPageUri || undefined}
            nextPage={pagination.nextPageUri || undefined}
        />
    );
};

export default ExemptionCertificateListPagination;
